import InstancesOnBehalfDialog from './InstancesOnBehalfDialog';

export default InstancesOnBehalfDialog;